<template lang="html">
  <i class="icon" :class="'icon-' + name"></i>
</template>

<script>
export default {
  props: ['name'],
};
</script>

<style lang="scss">
.icon {
}
</style>



// WEBPACK FOOTER //
// src/parts/components/icon.vue